import { useNavigate } from 'react-router-dom'
import Navigation from './Navigation/Navigation'
import { AccountLink } from '@think-internet/zeus-frontend-package/auth/types'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import useDidScroll from './useDidScroll'
import Container from '../../Container/Container'
import LargeContainer from '../../Container/LargeContainer'

type Props = { hideNavigation?: boolean; disableDynamicHeight?: boolean; small?: boolean; customLogo?: string; wide?: boolean }

const Header: React.FC<Props> = ({ hideNavigation = false, disableDynamicHeight = false, small = false, customLogo, wide }) => {
  const navigate = useNavigate()
  const accountLink: AccountLink = useSelector((s) => s[props.ACCOUNT_LINK])
  const isLoggedIn = () => !!accountLink
  const t = useSelector((s) => s[props.TRANSLATION])
  const didScroll = useDidScroll()

  const goHome = () => {
    let path = '/'
    if (isLoggedIn()) {
      path = accountLink.level === 'ADMIN' ? '/admin' : '/employee'
    }
    navigate(path)
  }

  const Core = (
    <div className="flex items-center justify-between w-full">
      <div onClick={goHome} className="cursor-pointer h-[70%] flex items-center font-bold text-md md:text-lg text-black">
        {t.logo}
      </div>
      {!hideNavigation && <Navigation />}
    </div>
  )

  return (
    <div
      className={`z-20 ${
        (didScroll && !disableDynamicHeight) || small ? 'h-16' : 'h-16'
      } transition-all top-0 left-0 fixed w-full bg-beige flex flex-row items-center shadow-sm`}
    >
      {wide ? <LargeContainer>{Core}</LargeContainer> : <Container>{Core}</Container>}
    </div>
  )
}

export default Header
